import {ApiClient} from '@hconnect/apiclient'
import {ExpertSystemHierarchyNode} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ReadableRootsQueryKey} from '../types'

export const useReadableRoots = (
  options?: Omit<UseQueryOptions<ExpertSystemHierarchyNode[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<ExpertSystemHierarchyNode[], AxiosError>({
    queryKey: [ReadableRootsQueryKey],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ExpertSystemHierarchyNode[]>(
        '/expert-system/kpis/hierarchy/readable-roots',
        {
          signal
        }
      )

      return response.data
    },
    refetchOnMount: false,
    staleTime: Infinity,
    ...options
  })
}
